import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';

@Component({
  selector: 'cp-ticket-container-dynamic',
  imports: [CommonModule],
  templateUrl: './ticket-container-dynamic.component.html',
  styleUrl: './ticket-container-dynamic.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketContainerDynamicComponent implements AfterViewInit {
  @Input() topHeightPx = 64;
  @Input() bottomHeightPx = 64;
  @Input() topTemplate: TemplateRef<unknown> | undefined;
  @Input() bottomTemplate: TemplateRef<unknown> | undefined;

  @ViewChild('svgElement') svgElement: ElementRef | undefined;

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.updateSvgWidth();
  }

  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  protected readonly lineOffsetX = 12;

  protected svgWidth = 300;

  ngAfterViewInit(): void {
    this.updateSvgWidth();
  }

  protected updateSvgWidth(): void {
    this.svgWidth = this.svgElement?.nativeElement.getBoundingClientRect().width;
    this.changeDetectorRef.detectChanges();
  }

  protected leftCutoutTransform(): string {
    return `translate(0, ${this.topHeightPx - 11})`;
  }

  protected rightCutoutTransform(): string {
    return `translate(${this.svgWidth - 6}, ${this.topHeightPx - 11})`;
  }
}
